import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

export default () => {
    const startEcho = () => {
        if (window.Pusher !== undefined && window.Echo !== undefined) {
            return;
        }

        window.Pusher = Pusher;
        window.Echo = new Echo({
            broadcaster: 'pusher',
            // Falls back to the production app, so nothing changes where the
            // variable is unset. A local environment broadcasting from a
            // different Pusher app has to say so in VITE_PUSHER_APP_KEY, or
            // the browser subscribes to an app the server never publishes to.
            key: import.meta.env.VITE_PUSHER_APP_KEY || 'beabf7065bb2c3bb61c7',
            cluster: 'eu',
            forceTLS: true,
        });
    };

    const stopEcho = () => {
        window.Echo?.disconnect();

        if (window.Echo !== undefined) {
            window.Echo = undefined;
        }
    };

    return {
        startEcho,
        stopEcho,
    };
};
